import { boot } from "quasar/wrappers";

/**
 * Meta Pixel tracking helpers
 * Gebruik these functions om events te tracken vanuit je Vue components.
 *
 * Voorbeeld:
 *   import { metaPixelEvents } from "src/boot/metapixel";
 *   metaPixelEvents.viewContent({ content_name: "landing_page" });
 */

// Base tracking functions
export function trackPageView() {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
}

export function trackEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
  }
}

export function trackCustomEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, params);
  }
}

// Named export met standaard Meta Pixel events + custom SoulProfiler events
export const metaPixelEvents = {
  // Standaard e-commerce / lead events
  viewContent: (params) => trackEvent("ViewContent", params),
  addToCart: (params) => trackEvent("AddToCart", params),
  initiateCheckout: (params) => trackEvent("InitiateCheckout", params),
  addPaymentInfo: (params) => trackEvent("AddPaymentInfo", params),
  purchase: (params) => trackEvent("Purchase", params),
  lead: (params) => trackEvent("Lead", params),
  completeRegistration: (params) => trackEvent("CompleteRegistration", params),

  // Custom SoulProfiler events
  previewCreated: (params) => trackCustomEvent("PreviewCreated", params),
  reportViewed: (params) => trackCustomEvent("ReportViewed", params),
  shopVisited: (params) => trackCustomEvent("ShopVisited", params),
  readingBooked: (params) => trackCustomEvent("ReadingBooked", params),
};

export default boot(({ router }) => {
  // Track page views bij route-wijzigingen (SPA)
  router.afterEach(() => {
    setTimeout(() => {
      trackPageView();
    }, 100);
  });
});
